<template>
  <div class="mb-10">
    <h2 class="text-lg font-semibold text-ink-900 mb-4">{{ title }}</h2>
    <div class="prose prose-sm max-w-none text-ink-700 leading-relaxed">
      <slot />
    </div>
  </div>
</template>

<script setup>
defineProps({
  title: { type: String, required: true },
});
</script>
